import appConfig from "../config/appConfig";
const API_BASE_URL = process.env.REACT_APP_DEFAULT_API_BASE_URL;

const levels = {
  debug: 1,
  info: 2,
  warn: 3,
  error: 4,
};

const shouldLog = (level) => {
  if (!appConfig.ENABLE_LOGGER) return false;

  const currentLevel = levels[appConfig.LOG_LEVEL] || 1;
  return levels[level] >= currentLevel;
};

const formatMessage = (level, message, meta) => {
  const timestamp = new Date().toISOString();

  return {
    timestamp,
    level: level.toUpperCase(),
    message,
    meta: meta || null,
    product_id: 2,
  };
};

const sendToServer = async (logData) => {
  try {
    await fetch(`${API_BASE_URL}Log/save_log`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(logData),
    });
  } catch (err) {
    console.error("Log API failed", err);
  }
};

const log = (level, message, meta = null) => {
  if (!shouldLog(level)) return;

  const logData = formatMessage(level, message, meta);

  // Console Output
  // if (meta) {
  //   console[level](
  //     `[${logData.timestamp}] [${logData.level}] ${message}`,
  //     meta
  //   );
  // } else {
  //   console[level](
  //     `[${logData.timestamp}] [${logData.level}] ${message}`
  //   );
  // }

  // Optional: Send to backend
  if (appConfig.SEND_LOGS_TO_SERVER) {
    sendToServer(logData);
  }
};

const logger = {
  debug: (message, meta) => log("debug", message, meta),
  info: (message, meta) => log("info", message, meta),
  warn: (message, meta) => log("warn", message, meta),
  error: (message, meta) => log("error", message, meta),
};

export default logger;